import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardWrapperComponent } from '../../../shared/components/card-wrapper/card-wrapper.component';
import { I18nPipe } from '../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-partner-inscription-success-cta',
  standalone: true,
  imports: [CommonModule, CardWrapperComponent, I18nPipe],
  templateUrl: './partner-inscription-success-cta.component.html',
  styleUrls: ['./partner-inscription-success-cta.component.scss'],
})
export class PartnerInscriptionSuccessCtaComponent {
  @Input() showSuccess = false;

  /** Disparado ao clicar em «Portal do Parceiro» (fluxo de acompanhamento no cadastro de parceiros). */
  @Output() partnerPortalClick = new EventEmitter<void>();

  onPartnerPortalClick(): void {
    this.partnerPortalClick.emit();
  }
}
